import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle, XCircle, Warning, MapPin, CalendarBlank, Ticket as TicketIcon } from "@phosphor-icons/react";

export default function VerifyPage() {
  const { serial } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/verify/${serial}`)
      .then(({ data }) => setData(data))
      .catch(() => setData({ valid: false, reason: "Lookup failed" }))
      .finally(() => setLoading(false));
  }, [serial]);

  if (loading) {
    return <div className="min-h-[70vh] flex items-center justify-center text-neutral-500" data-testid="verify-loading">Verifying…</div>;
  }

  const t = data?.ticket;
  const isUsed = data?.used;
  const isValid = data?.valid;

  return (
    <div className="min-h-[80vh] bg-[#F8F9FA] py-12 px-6" data-testid="verify-page">
      <div className="max-w-xl mx-auto">
        <div className={`p-8 ${isValid ? "bg-[#10B981]" : isUsed ? "bg-[#10B981]" : "bg-[#0A0A0A]"} text-white text-center`}>
          {isValid ? (
            <>
              <CheckCircle size={64} weight="fill" className="mx-auto" />
              <h1 className="font-display text-4xl mt-4 tracking-tighter">Valid Ticket</h1>
              <p className="text-sm opacity-80 mt-2">Present this confirmation at the gate.</p>
            </>
          ) : isUsed ? (
            <>
              <CheckCircle size={64} weight="fill" className="mx-auto" />
              <h1 className="font-display text-4xl mt-4 tracking-tighter">You're in!</h1>
              <p className="text-sm opacity-80 mt-2">Enjoy the event!</p>
            </>
          ) : (
            <>
              <XCircle size={64} weight="fill" className="mx-auto" />
              <h1 className="font-display text-4xl mt-4 tracking-tighter">Not Valid</h1>
              <p className="text-sm opacity-80 mt-2">{data?.reason || "Ticket not found in our system."}</p>
            </>
          )}
        </div>

        {t && (
          <div className="bg-white border border-t-0 border-neutral-200 p-8" data-testid="verify-details">
            <p className="label-eyebrow">Serial</p>
            <p className="font-mono text-[#4F46E5] font-bold mt-1" data-testid="verify-serial">{t.serial}</p>
            <h2 className="font-display text-2xl mt-4">{t.event_title}</h2>
            <div className="mt-4 space-y-2 text-sm text-neutral-700">
              <p className="flex items-center gap-2"><CalendarBlank size={16} /> {t.event_date && new Date(t.event_date).toLocaleString()}</p>
              <p className="flex items-center gap-2"><MapPin size={16} /> {t.venue}</p>
              <p className="flex items-center gap-2"><TicketIcon size={16} /> {t.ticket_type_name} · {t.gate}</p>
              {t.user_name && <p className="text-xs text-neutral-500 mt-3">Holder: {t.user_name}</p>}
            </div>
          </div>
        )}

        <div className="mt-6 text-center text-xs text-neutral-500">
          Verified by <Link to="/" className="text-[#4F46E5] font-bold">TicketUp</Link>.
        </div>
      </div>
    </div>
  );
}
